import {NY_CountryService} from "../../services/country-service";
import App from "../app";
import {formatPrice, Variant} from "../../models/product";
import {Component, ComponentChild, h, RenderableProps} from "preact";

interface Props {
  styles: { [key: string]: string }
  variant: Variant
}

export class ProductPrice extends Component<Props, any> {
  render({variant, styles}: RenderableProps<Props>): ComponentChild {
    return (
      <>
        {variant.showPriceLabel() && <div class={styles['price-container']}>
          {variant.sale ?
            <div class={styles['sale-container']}>
              <div class={styles["sale-price-container"]}>
                {(NY_CountryService.showOriginalPrice(App.countryCode) &&
                    <span class={styles['original-price']}>
                            {formatPrice(variant.originalPrice, variant.currency)}
                          </span>)}

                <span class={styles['sale-price']}>
                  {formatPrice(variant.currentPrice, variant.currency)}
                </span>
              </div>
            </div>

            : <div class={styles['current-price-container']}>
              <span>
                 {formatPrice(variant.currentPrice, variant.currency)}
              </span>
            </div>
          }
        </div>
        }
      </>
    )

  }
}